import { render, staticRenderFns } from "./BookDeliveryPurchaseReport.vue?vue&type=template&id=10e9ac36&scoped=true"
import script from "./BookDeliveryPurchaseReport.vue?vue&type=script&lang=js"
export * from "./BookDeliveryPurchaseReport.vue?vue&type=script&lang=js"
import style0 from "./BookDeliveryPurchaseReport.vue?vue&type=style&index=0&id=10e9ac36&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10e9ac36",
  null
  
)

export default component.exports